<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :label-width="$root.labelWidth"
      label-position="top"
      v-loading="validating"
    >

      <el-row :gutter="20" align="middle">
        <el-col :md="12">
          <el-form-item :label="$t('modules.user.fields.email.label')" prop="email">
            <el-input type="email" v-model.lazy.trim="formData.email" :placeholder="$t('modules.user.fields.email.placeholder')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="6" :sm="24">
          <el-form-item :label="$t('modules.user.fields.locale.label')" prop="locale">
            <el-select v-model.lazy="formData.locale">
              <el-option v-for="(localeConfig, locale) in locales" :key="locale" :value="locale" :label="localeConfig.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="6" :sm="24">
          <el-form-item :label="$t('modules.user.fields.timezone.label')" prop="timezone">
            <el-select 
              filterable
              remote
              reserve-keyword 
              v-model.lazy="formData.timezone">
              <el-option v-for="(timezone, index) in timezones" :key="index" :value="timezone" :label="timezone"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" align="middle">
        <el-col :md="12" :sm="24">
          <el-form-item :label="$t('modules.user.fields.password.label')" prop="password">
            <el-input type="password" v-model.lazy.trim="formData.password" :placeholder="$t('modules.user.fields.password.placeholder')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="12" :sm="24">
          <el-form-item :label="$t('modules.user.fields.passwordConfirmation.label')" prop="password_confirmation">
            <el-input type="password" v-model.lazy.trim="formData.password_confirmation" :placeholder="$t('modules.user.fields.passwordConfirmation.placeholder')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" align="middle">
        <el-col>
          <el-form-item>
            <el-button type="primary" @click="submitForm()">{{ $t('buttons.save') }}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
          
    </el-form>
  </div>
</template>

<script>
  import moment from 'moment';
  import 'moment-timezone';

  import { mapActions, mapGetters } from 'vuex';
  import validations from '@/utils/validations';
  import availableLocales from '@/i18n/available_locales';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';
  import formPopulator from '@/mixins/form_populator';

  export default {
    name: 'AccountProfileForm',
    mixins: [formPopulator],
    created() {
      this.populateFormWithModel('currentUser');
    },
    data() {
      return {
        translationPrefix: 'pages.accountSettings',
        locales: availableLocales,
        timezones: moment.tz.names(),
        rules: {
          email: [
            { ...validations.required },
            { ...validations.email },
          ],
          locale: [
            { ...validations.required },
          ],
          timezone: [
            { ...validations.required },
          ],
        },
        formData: {
          email: '',
          password: '',
          password_confirmation: '',
          locale: '',
          timezone: '',
        },
      };
    },
    computed: {
      ...mapGetters('entities/users', ['currentUser', 'validating']),
    },
    methods: {
      ...mapActions('entities/users', ['updateAccount']),
      submitForm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.updateAccount(this.formData)
              .then((response) => {
                if (response.status) {
                  if (this.formData.password && this.formData.password !== '') {
                    this.logoutUser();
                  } else {
                    showSuccessMessage(this.$t('modules.user.messages.accountUpdated'));
                  }
                } else {
                  showErrorMessage(response.error);
                }
              });
          } else {
            showErrorMessage(this.$t('form.messages.notValid'));
            return false;
          }

          return true;
        });
      },
      logoutUser() {
        this.$store.dispatch('entities/users/logout')
          .then(() => {
            showSuccessMessage(this.$t('modules.user.messages.passwordUpdated'));
            this.$router.push({ name: 'home' });
          });
      },
    },
  };
</script>




// WEBPACK FOOTER //
// src/components/user/AccountProfileForm.vue